var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.ready)?_c('v-icon',{attrs:{"color":_vm.healthUtil.colorForStatus(_vm.rdata.status)}},[_vm._v("mdi-medical-bag")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }